import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentRegisterComponent } from './payment-register/payment-register.component';
import { PaymentService } from './payment.service';

@NgModule({
  imports: [CommonModule, CoreModule, PaymentRoutingModule],
  declarations: [PaymentRegisterComponent],
  providers: [PaymentService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PaymentModule {}
